import type { PmoDeliveryResponse } from '../../types/pmo-delivery.js';
import { request } from './_request.js';

/**
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business PMOデリバリーview APIクライアント。四半期を指定して遅延トレンド・原因内訳・リリースサマリー一式と四半期選択肢を取得
 * @graph-connects /kpi/pmo-flow/delivery [calls] PMOデリバリーviewAPI
 */
export const pmoDeliveryApi = {
  /**
   * @param quarter 四半期キー（`FY2027-1`）。未指定なら進行中の四半期
   */
  getView: async (quarter?: string): Promise<PmoDeliveryResponse> => {
    const query = quarter ? `?quarter=${encodeURIComponent(quarter)}` : '';
    return await request<PmoDeliveryResponse>(`/kpi/pmo-flow/delivery${query}`);
  },
};
